import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppComponent } from './app.component';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { initializeFirestore, persistentLocalCache, provideFirestore } from '@angular/fire/firestore';
import { AngularFireStorageModule, BUCKET } from '@angular/fire/compat/storage';
import { environment } from '../environments/environment';
import { DataService } from './_services/data.service';
import { AuthService } from './_services/auth.service';
import { AdminGuard } from './_core/_guard/admin.guard';
import { EditorGuard } from './_core/_guard/editor.guard';

import { CanReadGuard } from './_core/_guard/can-read.guard';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './_core/core.module';
import { DropZoneDirective } from './_core/_directive/drop-zone.directive';
import { NgInitDirectiveDirective } from './_core/_directive/ng-init-directive.directive';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { AngularDraggableModule } from 'angular2-draggable';
import { SharedModule } from './shared/shared.module';
// import { AdminModule } from './admin/admin.module';
// import { EditorModule } from './editor/editor.module';
import { UsersModule } from './users/users.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// For Translate
import { TranslateModule, TranslateService, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Observable } from 'rxjs';
import { from, of } from 'rxjs';
import * as en from './../assets/i18n/en.json';
import * as he from './../assets/i18n/he.json';
import * as ar from './../assets/i18n/ar.json';
import { ServiceWorkerModule } from '@angular/service-worker';
// import * as firebase from 'firebase';
import { Title } from '@angular/platform-browser';
import { GoogleAnalyticsService } from './_services/google-analytics.service';
import { Page404Component } from './page404/page404.component';

import { CreateRoomComponent } from './pages/create-room/create-room.component';
import { MatDialogModule } from '@angular/material/dialog';
import { JitsiComponent } from './pages/jitsi/jitsi.component';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { UsersComponent } from './calculator-offer/users/users.component';
import { AuthCallbackComponent } from './_core/auth-callback/auth-callback.component';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';

// import { NgxSliderModule } from '@angular-slider/ngx-slider';

// For Translate


export class WebpackTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    switch (lang) {
      case 'he':
        return of((he as any).default);
      case 'en':
        return of((en as any).default);
      case 'ar':
        return of((ar as any).default);
    }
  }
}
@NgModule({
    declarations: [
        AppComponent,
        DropZoneDirective,
        CreateRoomComponent,
        NgInitDirectiveDirective,
        Page404Component,
        JitsiComponent,
        UsersComponent,
        AuthCallbackComponent,
    ],
    imports: [
        HttpClientModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        AngularDraggableModule,
        MatCheckboxModule,
        MatRadioModule,
        MatTabsModule,
        AngularFireAuthModule,
        AppRoutingModule,
        AngularFireModule.initializeApp(environment.firebase),
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideFirestore(() =>
          initializeFirestore(
            getApp(),
            { localCache: persistentLocalCache() },
            environment.firestoreDatabaseId,
          ),
        ),
        AngularFireDatabaseModule,
        CoreModule,
        BrowserAnimationsModule,
        AngularFireStorageModule,
        Ng2ImgMaxModule,
        // AdminModule,
        UsersModule,
        MatDialogModule,
        // AngularFirestoreModule.enablePersistence(),
        // EditorModule,
        // For Translate
        TranslateModule.forRoot({
            defaultLanguage: 'he',
            loader: {
                provide: TranslateLoader,
                useClass: WebpackTranslateLoader
            }
        }),
        HttpClientModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        // For Translate
        // PdfViewerModule,
        MatListModule,
        MatIconModule,
    ],
    providers: [
        { provide: BUCKET, useValue: environment.storageBucketUrl },
        DataService,
        AuthService,
        AdminGuard,
        EditorGuard,
        CanReadGuard,
        CookieService,
        TranslateService,
        Document,
        Title,
        GoogleAnalyticsService,
        GoogleMap,
        MapMarker,
        MapInfoWindow
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private translate: TranslateService) {

    translate.addLangs(["en", "he", "ar"]);
    // translate.setDefaultLang('he');

    let browserLang = translate.getBrowserLang();
    // translate.use('he');
  }
}
  //For mobile development, it is turned on by default
// firebase.firestore().enablePersistence()
//   .catch(function(err) {
//       if (err.code == 'failed-precondition') {
//           // Multiple tabs open, persistence can only be enabled
//           // in one tab at a a time.
//           // ...
//       } else if (err.code == 'unimplemented') {
//           // The current browser does not support all of the
//           // features required to enable persistence
//           // ...
//       }
//   });
// firebase.firestore().settings({
//   cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
// });

// firebase.firestore().enablePersistence()

